import React from 'react';
import { isLightMode, toggleTheme } from '../../core/utils/globalTheme';
import { isSaudiBrand } from '../../products/saudi/utils/isSaudiBrand';

/**
 * React Hook for Global Theme System
 * Lightweight wrapper that re-renders on theme change
 */
export function useGlobalTheme() {
  const saudiBrand = isSaudiBrand();
  const [isLight, setIsLight] = React.useState(saudiBrand ? true : isLightMode());
  
  React.useEffect(() => {
    if (saudiBrand) {
      setIsLight(true);
      return undefined;
    }

    const handleThemeChange = (event) => {
      setIsLight(event.detail.isLight);
    };

    window.addEventListener('qawaem-theme-change', handleThemeChange);

    return () => {
      window.removeEventListener('qawaem-theme-change', handleThemeChange);
    };
  }, [saudiBrand]);
  
  const toggle = React.useCallback(() => {
    const newTheme = toggleTheme();
    setIsLight(newTheme === 'light');
  }, []);
  
  return {
    isDashboardLightMode: saudiBrand ? true : isLight,
    isLight: saudiBrand ? true : isLight,
    isDark: saudiBrand ? false : !isLight,
    toggleDashboardTheme: saudiBrand ? () => true : toggle,
    toggle: saudiBrand ? () => true : toggle,
  };
}

export default useGlobalTheme;
